import { ZervantLocale } from '@features/invoices/enums/zervantLocale'

export const localeToLanguageBannerTKey: Partial<Record<ZervantLocale, string>> = {
  [ZervantLocale.DE_DE]: 'external_invoices.editor.form.invoice_language_change_preview_banner.info.de_DE',
  [ZervantLocale.EN_GB]: 'external_invoices.editor.form.invoice_language_change_preview_banner.info.en_GB',
  [ZervantLocale.FR_FR]: 'external_invoices.editor.form.invoice_language_change_preview_banner.info.fr_FR',
  [ZervantLocale.NL_NL]: 'external_invoices.editor.form.invoice_language_change_preview_banner.info.nl_NL',
}
